import { Injectable } from '@angular/core';

import { IMedia } from '../_interfaces/media.interface';
import { SdLibConfig } from '../sd-lib-config';

export type ImageSnippet = {
  '@context': 'https://schema.org/';
  '@type': 'ImageObject';
  contentUrl: string;
  creditText: string;
  creator: {
    '@type': 'Organization';
    name: string;
  },
  copyrightNotice: string;
};

export type VideoSnippet = {
  '@context': 'https://schema.org/';
  '@type': 'VideoObject';
  name: string;
  thumbnailUrl: string;
  embedUrl: string;
  uploadDate: string;
};

export type VideoInfo = {
  videoTitle: string;
  videoId: string;
  thumbnailUrl: string;
  creationTime: string;
};

@Injectable({
  providedIn: 'root'
})
export class SnippetMapper {
  constructor(public sdLibConfig: SdLibConfig) {}

  mapImageSnippet(data: IMedia): ImageSnippet {
    const currentBrand = this.sdLibConfig.currentBrand;

    return {
      '@context': 'https://schema.org/',
      '@type': 'ImageObject',
      contentUrl: data.urlTwicPic.includes('https')
        ? data.urlTwicPic
        : 'https://' + data.twicPicsDomain + '' + data.urlTwicPic.split('image:')[1],
      creditText: data.altText,
      creator: {
        '@type': 'Organization',
        name: currentBrand
      },
      copyrightNotice: currentBrand
    };
  }

  mapVideoSnippet(data: VideoInfo, title: string, origin: string): VideoSnippet {
    return {
      '@context': 'https://schema.org/',
      '@type': 'VideoObject',
      name: title,
      thumbnailUrl: data?.thumbnailUrl,
      embedUrl: 'https://www.youtube.com/embed/' + data?.videoId + '?enablejsapi=1&origin=' + origin,
      uploadDate: data?.creationTime
    };
  }
}
